import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FAQAccordion = ({ items, categoryColor }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(prev => prev === i ? null : i);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      {items?.map((item, i) => (
        <div key={i} style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(224,228,232,0.08)', borderRadius: '2px', overflow: 'hidden' }}>
          <button
            onClick={() => toggle(i)}
            style={{
              width: '100%',
              background: openIndex === i ? 'rgba(255,87,34,0.05)' : 'none',
              border: 'none',
              borderLeft: openIndex === i ? '3px solid #FF5722' : '3px solid transparent',
              padding: '20px 24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '16px',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'background 200ms ease, border-color 200ms ease',
            }}
          >
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 600, color: openIndex === i ? 'var(--color-foreground)' : 'rgba(224,228,232,0.85)', letterSpacing: '0.01em', lineHeight: 1.4 }}>
              {item?.question}
            </span>
            <motion.div
              animate={{ rotate: openIndex === i ? 45 : 0 }}
              transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
              style={{ flexShrink: 0, width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={openIndex === i ? '#FF5722' : 'rgba(224,228,232,0.4)'} strokeWidth="2.5">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            </motion.div>
          </button>
          <AnimatePresence initial={false}>
            {openIndex === i && (
              <motion.div
                key="content"
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                style={{ overflow: 'hidden' }}
              >
                <div style={{ padding: '0 24px 24px 27px', borderLeft: '3px solid rgba(255,87,34,0.3)' }}>
                  <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', fontWeight: 400, color: 'var(--color-muted-foreground)', lineHeight: 1.8 }}>
                    {item?.answer}
                  </p>
                  {item?.note && (
                    <div style={{ marginTop: '12px', padding: '10px 14px', background: 'rgba(0,79,152,0.08)', border: '1px solid rgba(0,79,152,0.2)', borderRadius: '2px' }}>
                      <p style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'rgba(100,160,255,0.8)', lineHeight: 1.6 }}>{item?.note}</p>
                    </div>
                  )}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;
